module.exports = __webpack_public_path__ + "static/picture-164308d4564e60c8dbd2697744d79990.jpeg";